import React, { Component } from "react";
import data from "../../src/data/mainData.json"
import Navbar from "./global-components/navbar";
import PageHeader from './global-components/page-header';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';

class client_feedback extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    const testimonials = data?.testimonials || [];

    return (
        <>
        <Navbar />
        <PageHeader headertitle="Client Feedback" subheader="Client Feedback" />

      <div
        className=" pt-50 pb-70"
        data-bs-bg={publicUrl + "assets/img/bg/20.jpg"}
      >
        <div className="container">
          {/* Title */}
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center">
                
                <h1 className="section-title">Our Clients</h1>
              </div>
            </div>
          </div>
          

          {/* Videos Grid */}
          <div className="row">
            {testimonials.map((item) => (
               <div className="col-lg-3 col-md-6 col-sm-12 mb-30" key={item.id}>
                <div className="ltn__testimonial-item ltn__testimonial-item-7">
                  <div className="ltn__testimoni-info">
                    <div className="ltn__testimonial-video">
                      <video
                        width="100%"
                        height="100%"
                        controls
                        controlsList="nodownload"
                        disablePictureInPicture
                        onContextMenu={(e) => e.preventDefault()}
                      >
                        <source src={item.video} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  </div>
                    <p className="text-start mx-3 mb-0 text-wrap" style={{ color: "#2DBB62"}}>Client: <span className="text-dark">{item.name}</span></p>
                     <p className="text-start mx-3 mb-0 text-wrap" style={{ color: "#2DBB62"}}>Published Date: <span className="text-dark">{item.published_date}</span></p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
       <CallToActionV1 />
        <Footer />
      </>
    );
  }
}

export default client_feedback;
